module.exports = __webpack_public_path__ + "static/media/halo-auto-image.dacc9047.svg";